import '.ec{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ed{padding-left:1.5rem;}.ssr-plugin'
import '.ee{margin:1rem 0;}.ssr-plugin'
import '.ef{color:var(--gray-700);}.ssr-plugin'
import '.eg{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="ec ed ee ef eg"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
